import { writable } from 'svelte/store';

const create_car_play_select = () => {
	//this is used for IOS car play service
	const { subscribe, set, update } = writable(
		JSON.parse(localStorage.getItem('car_play_devices')) || [],
	);

	return {
		subscribe,
		set,
		update_list: (device) => {
			update((list) => {
				if (list.includes(device)) {
					list.splice(list.indexOf(device), 1);
				} else {
					list.push(device);
				}
				return list;
			});
		},
		reset_list: () => set([]),
	};
};

export const selected_for_car_play = create_car_play_select();

selected_for_car_play.subscribe((val) => localStorage.setItem('car_play_devices', JSON.stringify(val)));
